import { type UseMutationResult, useMutation } from 'react-query';
import { ParticipantService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetAwardedParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setModalData: any,
  openModal: () => void
): UseMutationResult<any, unknown, void, unknown> => {
  return useMutation(
    async () => {
      return await handleRequest(
        ParticipantService.getApiAwardApiAppParticipantAwardedParticipants()
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          setModalData(response);
          openModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetAwardedParticipantList;
